import _ from 'lodash/fp';

var fp = _.noConflict();

import Ncs from '../index';

function offset(page, pageSize) {
  return (page - 1) * pageSize;
}

function page(offset, pageSize) {
  return offset / pageSize + 1;
}

export default {
  namespaced: true,
  state: {
    // Properties shown in form
    offset: 0,
    pageSize: null,
    // Properties of the current kwic result
    numberOfElements: null,
    currentOffset: null,
    currentPageSize: null
  },
  mutations: {
    setPageSize: function setPageSize(s, p) {
      s.pageSize = p;
      s.offset = 0;
    },
    setSelectedPage: function setSelectedPage(s, p) {
      s.offset = offset(p, s.pageSize);
      s.currentSelectedOffset = s.offset;
    },
    apiCompleteCallback: function apiCompleteCallback(s, p) {
      s.numberOfElements = fp.getOr(null, 'result.pagination.rows', p);
      s.currentOffset = fp.getOr(null, 'query.pagination.offset', p);
      s.currentPageSize = fp.getOr(null, 'query.pagination.pageSize', p);
    },
    restoreSnapshot: function restoreSnapshot(s, v) {
      s.offset = Number(v.offset) || 0;
      s.pageSize = Number(v.pageSize);
      s.numberOfElements = Number(v.numberOfElements);
      s.currentOffset = Number(v.currentOffset) || 0;
      s.currentPageSize = Number(v.currentPageSize) || s.pageSize;
    }
  },
  getters: {
    snapshot: function snapshot(s) {
      return {
        offset: s.offset,
        pageSize: s.pageSize,
        numberOfElements: s.numberOfElements,
        currentOffset: s.currentOffset,
        currentPageSize: s.currentPageSize
      };
    },
    required: function required(s) {
      return s.numberOfElements > s.currentPageSize;
    },
    currentPage: function currentPage(s) {
      return page(s.currentOffset, s.currentPageSize);
    },
    previousPage: function previousPage(s, g) {
      return g.currentPage > 1 ? g.currentPage - 1 : null;
    },
    nextPage: function nextPage(s, g) {
      return g.currentPage !== g.lastPage ? g.currentPage + 1 : null;
    },
    currentPageSize: function currentPageSize(s) {
      return s.currentPageSize;
    },
    lastPage: function lastPage(s) {
      return Math.ceil(s.numberOfElements / s.currentPageSize);
    },
    resultsInCurrentPage: function resultsInCurrentPage(s, g) {
      return g.currentPage !== g.lastPage ? s.currentPageSize : s.numberOfElements - s.currentOffset;
    },
    selectedPage: function selectedPage(s, g) {
      return page(s.offset, s.pageSize);
    },
    emptyResult: function emptyResult(s) {
      return s.numberOfElements === 0;
    },
    query: function query(s) {
      return {
        offset: s.offset,
        pageSize: s.pageSize
      };
    }
  },
  actions: {
    selectPage: function selectPage(_ref, page) {
      var state = _ref.state,
          dispatch = _ref.dispatch,
          commit = _ref.commit,
          getters = _ref.getters;
      var valid = page >= 1 && page <= getters.lastPage;
      valid && commit('setSelectedPage', page);
      return valid;
    },
    changePage: function changePage(_ref2, page) {
      var state = _ref2.state,
          dispatch = _ref2.dispatch,
          commit = _ref2.commit,
          getters = _ref2.getters;

      if (dispatch('selectPage', page)) {
        dispatch('api/execute', null, {
          root: true
        });
      }
    },
    reset: function reset(_ref3) {
      var state = _ref3.state,
          dispatch = _ref3.dispatch,
          commit = _ref3.commit,
          getters = _ref3.getters,
          rootGetters = _ref3.rootGetters;
      commit('setPageSize', Ncs.config.pagination.defaultPageSize);
      commit('setSelectedPage', 1);
    }
  }
};